import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BookingForm from "../components/BookingForm";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

const BookingPage = () => {
  return (
    <div style={{ overflow: "hidden" }}>
      {/* Background pattern */}
      <div style={{ 
        position: "fixed", 
        width: "100%", 
        height: "100vh", 
        zIndex: -1,
        backgroundImage: "url('/images/world-map-background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.05
      }} />
      
      <Header />
      
      {/* Hero Section */}
      <Box
        sx={{
          width: "100%",
          pt: { xs: 6, md: 10 },
          pb: { xs: 4, md: 6 },
          background: "linear-gradient(to bottom, rgba(219,53,42,0.05) 0%, rgba(255,255,255,1) 100%)",
          position: "relative"
        }}
      >
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <Typography
                variant="h2"
                component="h1"
                sx={{ 
                  fontWeight: "bold",
                  color: "#db352a",
                  mb: 2,
                  position: "relative",
                  display: "inline-block",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    width: "60%",
                    height: "4px",
                    backgroundColor: "#db352a",
                    bottom: "-12px",
                    left: "20%"
                  }
                }}
              >
                Book Your Trip
              </Typography>
              
              <Typography 
                variant="h6" 
                sx={{ 
                  maxWidth: "700px", 
                  mx: "auto", 
                  mt: 4,
                  color: "#555"
                }}
              >
                Fill out the form below to book your service. We'll get back to you shortly to confirm your reservation.
              </Typography>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* Booking Form Section */}
      <Box sx={{ 
        width: "100%", 
        py: 6, 
        background: "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(219,53,42,0.03) 100%)" 
      }}>
        <Container maxWidth="lg" sx={{ 
          display: "flex", 
          justifyContent: "center", 
          position: "relative" 
        }}>
          {/* Decorative elements */}
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            transition={{ duration: 1, delay: 0.5 }}
            src="illustrations/hourglass.png"
            alt="Decorative element"
            style={{
              position: "absolute",
              right: "5%",
              top: "10%",
              width: "120px",
              height: "auto",
              zIndex: 0,
              display: { xs: "none", md: "block" }
            }}
          />
          
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            transition={{ duration: 1, delay: 0.7 }}
            src="illustrations/pointer with signs in different directions.png"
            alt="Decorative element"
            style={{
              position: "absolute",
              left: "5%",
              bottom: "15%",
              width: "120px",
              height: "auto",
              zIndex: 0,
              display: { xs: "none", md: "block" }
            }}
          />
          
          <BookingForm />
        </Container>
      </Box>
      
      <Footer />
    </div>
  );
};

export default BookingPage;